import { Headline, HtmlContainer } from '@n2-common/ui';
import { N2ApplicationStatus } from '@n2-common/serverGeneratedTypings/n2ApplicationStatus';
import { ApplicationStatusPage, CommonStatusPageProps } from '@n2-common/components/ApplicationStatusPage';
import { useTranslation } from 'react-i18next';
import { useApplicationIdContext } from '@n2-common/components/ApplicationContext';
import { translationNamepaceFromProduct } from '../applicationStatusHelpers';
import { CmsFragementWithUtmVariants } from '@n2-common/components/CmsNotification';

const DeclinedPage = ({ navigateToCorrectStepFunc }: CommonStatusPageProps): JSX.Element => {
    const { productType, country, applicantId } = useApplicationIdContext();

    const translationNameSpace = translationNamepaceFromProduct(productType);

    const { t } = useTranslation(translationNameSpace);
  
    const countryStr = country?.toLowerCase();
    const cmsKeyBase = `declined_${translationNameSpace}_campaign_${countryStr}`;

    return (
        <ApplicationStatusPage
            navigateToCorrectStepFunc={navigateToCorrectStepFunc}
            correctStateFunc={(res) => res.Status === N2ApplicationStatus.Declined}
        >
            <Headline>{t<string>('ApplicationLandingPages.Declined.Headline')}</Headline>
            <Headline level={3}>{t<string>('ApplicationLandingPages.Declined.SubHeadline')}</Headline>
            <HtmlContainer innerHtml={t<string>('ApplicationLandingPages.Declined.Body', '')} />
            <CmsFragementWithUtmVariants cmsKeyBase={cmsKeyBase} linkData={[{ key: 'gpid', value: applicantId }]} />
        </ApplicationStatusPage>
    );
};

export default DeclinedPage;
